module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/move_1.a7f2f576.png";